import bus from "@/libs/bus.js";
import { getFormOptions } from "@/api/formoptions";

/*
 * 通過事件給予表單選項
 * */
export const assignFormOptions = async options => {
    // let { field, formOptions, remoteEndPoint } = options;
    let { field, formOptions } = options;
    // if (remoteEndPoint) {
    //     let remoteResult = await getFormOptions(remoteEndPoint);
    //     formOptions = remoteResult.data.options;
    // }
    bus.$emit("assignFormOptions", {
        field: field,
        formOptions: formOptions
    });
};

/*
 * 給定參數, 和後台獲取表單選項並更新表單
 * 若不需要從後台獲取, 參數中帶入 formOptions / disabledFormOptions 即可 (未實裝)
 * */

export const assignGroupName = async () => {
    let result = await getFormOptions(`/groupnames`);
    assignFormOptions({
        field: "groupName",
        formOptions: result.data.options
    });
};

export const assignServiceGroupName = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`/servicegroupnames?groupNames=${groupNames}`);
    assignFormOptions({
        field: "serviceGroupName",
        formOptions: result.data.options
    });
};

export const assignKeypairName = async options => {
    let { groupNames, serverNames } = options;
    let result = await getFormOptions(`/keypairnames?groupNames=${groupNames}&serverNames=${serverNames}`);
    assignFormOptions({
        field: "keypairname",
        formOptions: result.data.options
    });
};

export const assignUsedWafRules = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`/wafrules?groupNames=${groupNames}`);
    assignFormOptions({
        field: "usedWafRules",
        formOptions: result.data.options
    });
};

export const assignTags = async options => {
    let { groupNames, esIndex } = options;
    let result = await getFormOptions(`/tags?index=${esIndex}&groupName=${groupNames}`);
    assignFormOptions({
        field: "tags",
        formOptions: result.data.options
    });
};

export const assignAppProfileName = async options => {
    let { groupNames, withNone } = options;
    let result = await getFormOptions(`/app-profilenames?groupNames=${groupNames}&withNone=${withNone}`);
    assignFormOptions({
        field: "appProfileName",
        formOptions: result.data.options
    });
};

export const assignOrigins = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`/groupby/origins?groupName=${groupNames}`);
    assignFormOptions({
        field: "origins",
        formOptions: result.data.options
    });
};

export const assignHttpPort = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`/groupby/httpPort?groupName=${groupNames}`);
    assignFormOptions({
        field: "httpPort",
        formOptions: result.data.options
    });
};

export const assignHttpsPort = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`/groupby/httpsPort?groupName=${groupNames}`);
    assignFormOptions({
        field: "httpsPort",
        formOptions: result.data.options
    });
};

export const assignAlertChannelName = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`notificationchannels?groupNames=${groupNames}`);
    assignFormOptions({
        field: "alertChannelName",
        formOptions: result.data.options
    });
};

export const assignSlbName = async options => {
    let { groupNames, recordType } = options;
    let result = await getFormOptions(`/slbnames?groupNames=${groupNames}&recordType=${recordType}&serviceProvideType=false`);
    assignFormOptions({
        field: "slbs",
        formOptions: result.data.options
    });
};

export const assignProtectSlbName = async options => {
    let { groupNames, recordType } = options;
    let result = await getFormOptions(`/slbnames?groupNames=${groupNames}&recordType=${recordType}&serviceProvideType=true`);
    assignFormOptions({
        field: "protectSlbs",
        formOptions: result.data.options
    });
};

export const assignRecordLineName = async options => {
    let { groupNames, withRecordLineGroups, optionGrouping } = options;
    let result = await getFormOptions(
        `/recordlinenames?withRecordLineGroups=${withRecordLineGroups}&optionGrouping=${optionGrouping}&groupNames=${groupNames}`
    );
    assignFormOptions({
        field: "line",
        formOptions: result.data.options
    });
};

export const assignHealthCheckProbeName = async () => {
    let result = await getFormOptions(`/healthcheckprobenames`);
    assignFormOptions({
        field: "usedHealthCheckProbes",
        formOptions: result.data.options
    });
};

export const assignEdgeName = async options => {
    let { slbHostNames } = options;
    let result = await getFormOptions(`/edgenames?slbHostNames=${slbHostNames}`);
    assignFormOptions({
        field: "edges",
        formOptions: result.data.options
    });
};

export const assignGroupResourceSlbName = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`groupresource/slbnames?groupName=${groupNames}`);
    assignFormOptions({
        field: "slbs",
        formOptions: result.data.options
    });
};

export const assignGroupResourceEdgeName = async options => {
    let { groupNames } = options;
    let result = await getFormOptions(`groupresource/edgenames?groupName=${groupNames}`);
    assignFormOptions({
        field: "edges",
        formOptions: result.data.options
    });
};

export const assignAppProfileErrorHtmlPageName = async options => {
    let { groupNames, withDefault } = options;
    let result = await getFormOptions(`htmlpagenames?groupNames=${groupNames}&withDefault=${withDefault}`);
    assignFormOptions({
        field: "errorHtmlPageName",
        formOptions: result.data.options
    });
};

export const assignWafCustomHtmlPageName = async options => {
    let { groupNames, withDefault } = options;
    let result = await getFormOptions(`htmlpagenames?groupNames=${groupNames}&withDefault=${withDefault}`);
    assignFormOptions({
        field: "wafCustomHtmlPageName",
        formOptions: result.data.options
    });
};

export const assignWafDenyHtmlPageName = async options => {
    let { groupNames, withDefault } = options;
    let result = await getFormOptions(`htmlpagenames?groupNames=${groupNames}&withDefault=${withDefault}`);
    assignFormOptions({
        field: "wafDenyHtmlPageName",
        formOptions: result.data.options
    });
};

// form 參數類
export const assignMaxItemsCount = async (vm, field, val) => {
    try {
        let formItem = vm.allFormItems.find(item => item.key == field);
        if (!formItem) throw { msg: `field not found: ${field}` };
        formItem.maxItemsCount = val;
    } catch (err) {
        console.log(err);
    }
};



// WEBPACK FOOTER //
// ./src/libs/assignFormOptions.js